import { IClientValidator } from "./IClientValidator.js";

/**
 * Works with EmailUntrimmed.cs to perform unobtrusive validation in MVC against input
 * elements that must be a valid email address, but ignores any leading or trailing whitespace.
 *
 * This is required because copy / paste, password managers and some auto fill handlers
 * include a space at the end of the email address.
 */
export class EmailUntrimmed implements IClientValidator {
    public validate(value: string, element: HTMLInputElement, params: any): boolean {
        // Trim the value first, but handle the case where it is null.
        if (value) {
            value = value.trim();
        }
        else {
            // The default validator below allows whitespace through, so we need to handle this case.
            return false;
        }

        // Work around for gaining access to the private 'providers' array. GitHub issue - https://github.com/haacked/aspnet-client-validation/issues/134
        const untypedValidationService = window.validationService as any;
        // Use the base email validation now we have a trimmed value.
        return untypedValidationService.providers["email"](value, element, params);
    }
}


window.validators = window.validators || {};
window.validators.emailuntrimmed = new EmailUntrimmed();
